export const COLUMN_MIN_WIDTH = 48;
export const TABLE_FULL_WIDTH = 1800;
export const TABLE_MAX_WIDTH = 4000;
export const FULL_WIDTH_EDITOR_CONTENT_WIDTH = 1800;
export const MAX_SCALING_PERCENT = 0.3;
export const MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
// Used to calculate the width of a table using the Editor width
export const TABLE_EDITOR_MARGIN = 76;
const COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
export const TABLE_OFFSET_IN_COMMENT_EDITOR =
	2 * (COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);
